import { render, staticRenderFns } from "./scoreboard.vue?vue&type=template&id=a1be8c6c&scoped=true&"
import script from "./scoreboard.vue?vue&type=script&lang=js&"
export * from "./scoreboard.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard.vue?vue&type=style&index=0&id=a1be8c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1be8c6c",
  null
  
)

export default component.exports